export const PROJECTS = [
  {
    slug: "foxconn-a11-facility",
    title: "Foxconn A11 Facility",
    vertical: "MAXEK INFRA",
    vertical_slug: "maxek-infra",
    sector: "industrial",
    type: "Industrial Manufacturing Facility",
    industry: "Manufacturing",
    location: "Walajabad, Kancheepuram, Tamil Nadu",
    year: "2024",
    status: "Completed",
    project_value: "₹8 Crore",
    summary: "Industrial manufacturing facility delivered for the Foxconn A11 programme.",
    overview: "Engineering and execution support for the Foxconn A11 industrial manufacturing facility in Tamil Nadu.",
    scope: [],
    challenges: [],
    solutions: [],
    results: [],
    image: "/assets/projects/FOXCONN A11 FACILITY.webp",
    gallery: ["/assets/projects/FOXCONN A11 FACILITY.webp"],
    featured: true,
  },
  {
    slug: "foxconn-a04-facility",
    title: "Foxconn A04 Facility",
    vertical: "MAXEK INFRA",
    vertical_slug: "maxek-infra",
    sector: "industrial",
    type: "Industrial Manufacturing Facility",
    industry: "Manufacturing",
    location: "Walajabad, Kancheepuram, Tamil Nadu",
    year: "2024",
    status: "Completed",
    project_value: "₹5.5 Crore",
    summary: "Industrial manufacturing facility delivered for the Foxconn A04 programme.",
    overview: "Engineering and execution support for the Foxconn A04 industrial manufacturing facility in Tamil Nadu.",
    scope: [],
    challenges: [],
    solutions: [],
    results: [],
    image: "/assets/projects/FOXCONN A04 FACILITY.webp",
    gallery: ["/assets/projects/FOXCONN A04 FACILITY.webp"],
    featured: true,
  },
  {
    slug: "hilite-28-floor-tower",
    title: "HiLITE 28-Floor Tower",
    vertical: "MAXEK INFRA",
    vertical_slug: "maxek-infra",
    sector: "residential",
    type: "28-Floor Luxury Residential Tower",
    industry: "Real Estate",
    location: "Kerala, India",
    year: "2024",
    status: "Completed",
    project_value: "₹7 Crore",
    summary: "Engineering execution for a 28-floor luxury residential tower.",
    overview: "Engineering and construction execution support for a landmark high-rise residential development in Kerala.",
    scope: [],
    challenges: [],
    solutions: [],
    results: [],
    image: "/assets/projects/HILITE 28-FLOOR TOWER.webp",
    gallery: ["/assets/projects/HILITE 28-FLOOR TOWER.webp"],
    featured: false,
  },
  {
    slug: "sattva-knowledge-city",
    title: "Sattva Knowledge City",
    vertical: "MAXEK INFRA",
    vertical_slug: "maxek-infra",
    sector: "commercial",
    type: "Commercial IT & Business Park",
    industry: "Commercial",
    location: "Chennai, Tamil Nadu",
    year: "2024",
    status: "Completed",
    project_value: "₹9.5 Crore",
    summary: "Commercial engineering execution for Sattva Knowledge City.",
    overview: "Engineering and execution support for a major commercial IT and business park development.",
    scope: [],
    challenges: [],
    solutions: [],
    results: [],
    image: "/assets/projects/SATTVA KNOWLEDGE CITY.webp",
    gallery: ["/assets/projects/SATTVA KNOWLEDGE CITY.webp"],
    featured: true,
  },
  {
    slug: "kssia-one",
    title: "KSSIA ONE",
    vertical: "MAXEK SOLUTIONS",
    vertical_slug: "maxek-solutions",
    sector: "digital-platforms",
    type: "Digital Platform / Association Member Platform",
    industry: "Technology",
    location: "Thiruvananthapuram, Kerala",
    year: "2024",
    status: "Completed",
    client: "Kerala State Small Industries Association (KSSIA), Thiruvananthapuram District",
    developed_by: "MAXEK Private Limited",
    role: "Technology & Infrastructure Partner",
    core_purpose: "Connecting Members. Strengthening Industry.",
    about_platform: "KSSIA ONE brings members, industry information, events, and member services together in one digital environment.",
    summary: "Digital platform for KSSIA, Thiruvananthapuram District.",
    overview: "A unified digital environment for KSSIA members, programmes and services.",
    features: [
      "Member Directory",
      "Member Search",
      "Events & Programs",
      "Membership Renewal",
      "Notifications",
      "Member Services",
    ],
    who_it_serves: [
      "KSSIA members",
      "Small and medium-scale industrialists",
      "Entrepreneurs",
      "Member businesses",
    ],
    image: "/assets/projects/kssia.png",
    videos: [
      {
        src: "/assets/projects/kssia-app-building-intro.mp4",
        title: "KSSIA ONE — Building Introduction",
      },
      {
        src: "/assets/projects/kssia-building-forms.mp4",
        title: "KSSIA ONE — Forms & Login Walkthrough",
      },
    ],
    gallery: ["/assets/projects/kssia.png"],
    featured: true,
  },
  {
    slug: "recruitment-partner-people-excellence",
    title: "Recruitment Partner™ & People Excellence™ Engagement",
    vertical: "MAXEK BUSINESS HUB",
    vertical_slug: "maxek-business-hub",
    industry: "Industrial",
    location: "India",
    year: "2024",
    status: "Ongoing",
    summary: "Technical hiring and capability development delivered as one engagement for a scaling engineering firm.",
    overview: "Recruitment Partner™ addressed the hiring pipeline while People Excellence™ built internal capability and retention.",
    scope: [
      "Role definition and competency mapping",
      "Technical sourcing and structured screening",
      "Onboarding programme design",
      "Capability development pathways",
    ],
    challenges: ["Vacancies remained open across technical disciplines.", "Interview decisions were inconsistent."],
    solutions: ["Built competency-mapped role definitions.", "Introduced a scored interview framework."],
    results: ["Time to fill technical roles was reduced.", "New joiners reached productive contribution faster."],
    image: "https://images.unsplash.com/photo-1758518731706-be5d5230e5a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    gallery: ["https://images.unsplash.com/photo-1758518731706-be5d5230e5a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"],
    featured: false,
  },
  {
    slug: "digital-transformation-business-systems",
    title: "Digital Transformation™ & Business Systems™ Rollout",
    vertical: "MAXEK BUSINESS HUB",
    vertical_slug: "maxek-business-hub",
    industry: "Commercial",
    location: "India",
    year: "2025",
    status: "In Progress",
    summary: "Core business processes documented, systemised and automated for a multi-branch operation.",
    overview: "Digital Transformation™ and Business Systems™ established documented, systemised operations with automation applied to high-volume administrative work.",
    scope: [
      "Current-state process mapping across branches",
      "Standard operating procedure development",
      "Business automation for repetitive workflows",
      "Business intelligence reporting",
    ],
    challenges: ["Branches operated different informal processes.", "Reporting required manual consolidation."],
    solutions: ["Designed one standard operating model.", "Automated consolidated reporting."],
    results: ["One documented standard across branches.", "Administrative workload was reduced."],
    image: "https://images.unsplash.com/photo-1758518730037-a16581a040e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    gallery: ["https://images.unsplash.com/photo-1758518730037-a16581a040e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"],
    featured: false,
  },
  {
    slug: "maxek-edu-corporate-training-programme",
    title: "MAXEK EDU Corporate Training Programme",
    vertical: "MAXEK BUSINESS HUB",
    vertical_slug: "maxek-business-hub",
    industry: "Education",
    location: "India",
    year: "2025",
    status: "Ongoing",
    summary: "A structured corporate learning programme combining AI literacy, business skills and certification.",
    overview: "A corporate learning programme blending AI literacy, business fundamentals and role-specific certification.",
    scope: [
      "Skills gap assessment by role",
      "Curriculum design across learning tracks",
      "Workshop and instructor-led delivery",
      "Certification assessment framework",
    ],
    challenges: ["Digital skills varied across the workforce.", "Training time competed with project delivery."],
    solutions: ["Learners were streamed into appropriate tracks.", "Short modular sessions fitted around project commitments."],
    results: ["Capability improvement was recorded.", "Delivery continued without disrupting projects."],
    image: "https://images.unsplash.com/photo-1758691736424-4b4273948341?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    gallery: ["https://images.unsplash.com/photo-1758691736424-4b4273948341?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"],
    featured: false,
  },
];
